export default {
  com:{
    login:"登錄",
    user_login:"用戶登錄",
    login_and_registration:"登錄/註冊",
    registration: '註冊',
    customer_center:'遊客中心',
    quit:'退出',
    home:'首頁',
    the_country:'全國',
    enter_a_keyword: '請輸入關鍵字',
    more:'更多',
    with:'同',
    The_city:'市',
    cur_sign:'HK$',
    since:'起',
    Online_offer:'在線優惠',
    My_shop:'我的店鋪',
    my:'我的',
    Jump_to_the_shop:'跳轉到店鋪...',
    error:'出錯了！',
    access_computer :'訪問電腦版',
    Exit_successfully:'退出成功',
    Set_out:'出發',
    plan:'團期',
    none:'暫無',
    loading:'加載中...',
    No_more_data:'沒有更多數據了...',
    Product_screening:'產品篩選',
    Price_range:'價格區間',
    Travel_days:'行程天數',
    unlimited:'不限',
    day:'天',
    day_and_above:'天及以上',
    Departure_date:'出發日期',
    initiate:'開始',
    finish:'結束',
    open_turn_price:'是否開啟展示同行價',
    reset:'重置',
    OK:'確定',
    hundred: '百',
    thousand: '千',
    myriad: '萬',
    than_myriad: '萬以上',
    back:'返回',
    night:'晚',
    NO:'編號',
    Rise_of_man:'人起',
    Enjoy_discount:'可享優惠',
    The_following_prices_are_starting:'以下價格均為起價',
    Select_departure_city:'選擇出發城市',
    Itinerary_features:'行程特色',
    Daily_run:'日行程',
    Itinerary_arrangement:'行程安排',
    Cost_statement:'費用說明',
    Cost_included:'費用包含',
    Charges_are_not_included:'費用不包含',
    Trip_information:'行程信息',
    Visa_instructions:'簽證說明',
    Visa_attachment:'簽證附件',
    Change_the_cancellation_rules:'改退簽規則',
    the:'第',
    Have_dinner:'用餐',
    Put_up:'住宿',
    traffic:'交通',
    Itinerary_content:'行程內容',
    Reference_flight:'參考航班',
    Reference_hotel:'參考酒店',
    Matters_needing_attention:'註意事項',
    Contact_number:'聯系電話',
    Book_now:'立即預定',
    Preferential_policy:'優惠政策',
    verify:'確認',
    you_are_not_logged_in:'您還未登錄，登錄後可立即預定',
    you_account_has_not_been_peer_verified:'您的賬號還沒有進行同行認證哦，請先認證一下吧',
    your_account_has_not_been_approved:'您的賬號還未審核通過，審核通過後可下單',
    you_can_continue_booking_after_logging_in:'您還未登錄，登錄後可繼續預定',
    group_data_request_failed:'團期數據請求失敗，請稍後再試',
    Relevant_information:'相關信息',
    mobile_phone:'手機',
    submit:'提交',
    Please_fill_in:'請填寫',
    Please_enter:'請輸入',
    select_date_and_people:'選擇日期和人數',
    no_plan:'無團期',
    sunday:'日',
    one:'一',
    two:'二',
    three:'三',
    four:'四',
    five:'五',
    six:'六',
    group:'團',
    clustered:'已成團',
    Departure_city:'出發城市',
    Price_package:'價格套餐',
    information_resource_updated:'由於各資源信息實時更新,價格以訂單結算頁面價格為準',
    total_amount:'總額',
    detail:'明細',
    Further_booking:'繼續預定',
    Expense_detail:'費用明細',
    Basic_tour_fare:'基本團費',
    Grown_man:'成人',
    young:'小年輕',
    Old_Man:'老人',
    child:'小童',
    Children_not_bed:'小童不占床',
    Incidental_expenses:'雜費',
    one_guest_must_selected:'最少需選擇一名遊客',
    today:'今',
    tomorrow:'明',
    after_tomorrow:'後',
    people:'人',
    year:'年',
    month:'月',
    travel_information_filling:'出遊信息填寫',
    message:'信息',
    contact_person:'聯系人',
    mobile_phone_number:'手機號',
    required:'必填',
    receiving_SMS:'用于接收短信',
    venturette:'出遊人',
    order_note:'訂單備註',
    sell:'銷售',
    Select:'選擇',
    submit_an_order:'提交訂單',
    tips:'提示',
    Do_you_leave_page:'是否要離開此頁面?',
    no:'否',
    yes:'是',
    contact_name:'聯系人名稱',
    field_required:'是必填項',
    no_more_than_words:'不超過{0}字',
    enter_the_correct_one:'請輸入正確的',
    select_Sales:'請選擇銷售',
    order_expired:'訂單已失效',
    order_submitted_being_occupied:'訂單已提交，正在占位中',
    id_card_info_not_complete:'的身份證信息未填寫完整',
    passport_info_not_complete:'的護照信息未填寫完整',
    taiwan_info_incomplete:'的臺灣通行證信息未填寫完整',
    other_card_info_not_complete:'的其他證件信息未填寫完整',
    order_successful:'下單成功',
    contact_name:'聯系人姓名',
    bill_info:'賬單信息',
    edit_users:'編輯名單',
    ID_card:'身份證',
    Id_number:'身份證號',
    passport:'護照',
    Taiwan_pass:'臺灣通行證',
    Chinese_name:'中文名',
    Please_enter_your:'請輸入您的',
    English_name:'英文名',
    English_surname:'英文姓',
    sex:'性別',
    birth:'出生日期',
    save:'保存',
    number:'號碼',
    Date_of_issue:'簽發日期',
    validity:'有效期',
    information_has_been_saved:'已保存你填寫的信息',
    selected:'已選擇',
    Duplicate_Chinese_name:'中文名重復，請核對',
    Letter_only:'僅為字母',
    format_error:'格式不正確',
    document_information_saved:'證件信息已保存',
    M:'男',
    F:'女',
    document_number:'證件號碼',
    letter_only:'僅為字母',
    address:'地址',
    other:'其它',
    user_center:'個人中心',
    registered_member:'註冊會員',
    back_home:'回到首頁',
    change_password:'修改密碼',
    my_order:'我的訂單',
    Personal_data:'個人資料',
    Peer_certification:'同行認證',
    nickname:'昵稱',
    name:'姓名',
    To_be_reviewed:'待審核',
    audited:'已審核',
    To_be_Submitted:'待提交',
    Login_ban:'禁止登錄',
    Declined:'已拒絕',
    Company_name:'公司名稱',
    Home_province:'所在省市',
    Detailed_address:'詳細地址',
    original:'原',
    new:'新',
    Verify_mobile_phone_number:'驗證手機號碼',
    Picture_upload:'圖片上傳',
    Enterprise_information:'企業信息',
    Submit_for_review:'提交審核',
    Please_select:'請選擇',
    successfully: '成功',
    please:'請',
    operation:'操作',
    Be_saving:'保存中...',
    change: '修改',
    filter:'篩選',
    order:'訂單',
    distribution_order:'分銷訂單',
    ord_id:'訂單編號',
    order_time:'下單時間',
    confirm_ord:'確認單',
    reservation_order:'預留單',
    cancel_ord:'取消單',
    expire:'到期',
    round_trip_date:'往返日期',
    total:'合計',
    nopay:'未付',
    pay:'支付',
    cancel:'取消',
    no_more_orders:'沒有更多訂單了',
    lose:'失敗',
    is_cancel_the_order:'是否取消訂單?',
    order_cancelled:'訂單取消中...',
    list:'列表',
    Order_status:'訂單狀態',
    all:'全部',
    valid_ord:'有效單',
    Valid_order:'有效訂單',
    Date_type:'日期類型',
    Order_date:'下單日期',
    Departure_date:'出團日期',
    Start_date:'開始日期',
    End_date:'結束日期',
    keyword:'關鍵字',
    enter_order_number_and_line:'請輸入訂單號、線路名稱',
    search:'搜索',
    Order_details:'訂單詳情',
    Apply_invoice:'申請發票',
    confirmation:'確認書',
    Letter_departure:'出團通知書',
    Add_on_product:'附加產品',
    commission:'傭金',
    Number_of_people:'人數',
    Number_of_tourists:'遊客人數',
    Recommended:'推薦',
    Payment_amount:'付款金額',
    Outbound_information:'出遊人信息',
    tourist:'遊客',
    unaudited:'未審核',
    add:'新增',
    edit:'編輯',
    addressee:'收件人',
    Not_submitted:'未提交',
    Get_configuration:'獲取配置',
    Bank_account_number:'銀行賬號',
    Click_upload:'點擊上傳',
    telephone:'電話',
    attachment:'附件',
    My_member:'我的會員',
    Basic_information:'基本信息',
    copy:'復製',
    hold_the_QR_code_share:'長按二維碼保存或分享',
    Please_enter_an_integer:'請輸入整數',
    Copied:'已復製',
    Please_upload:'請上傳',
    Account_number:'賬號',
    Effective_singular:'有效單數',
    Commission_rebate:'返傭金額',
    no_data:'無數據...',
    shop:'店鋪',
    share:'分享',
    favorite:'收藏',
    product_down:'產品已下架',
    return_prev_page:'返回上一頁',
    sorry_page_not_found:'對不起，您訪問的頁面不存在...',
    you_can_enter_N_characters: '當前還能輸入N個文字',
    words_you_entered_exceeded_limit: '你輸入的文字數超過限製',
    Peer_password:'同行密碼',
    email:'郵箱',
    more_than:'餘',
    default_priceName:'默認套餐',
    adult_price:'成人價',
    small_price:'小年輕價',
    oldman_price:'老人價',
    child_price:'小童價',
    not_bed_price:'小童不占床價',
    hk_and_mo_residents:'港澳通行證',

  },

  /////////////////////////////////////////////////以下是登录相关///////////////////////////////
  login:{
    password:'密碼',
    enter_your_mobile:'請輸入手機號碼',
    enter_your_password:'請輸入您的密碼',
    Sign_now:'立即登錄',
    Forgot_password:'忘記密碼',
    No_account_Register_now:'沒有賬號?立即註冊',
    third_party_account_log_in:'使用第三方賬號登錄',
    Log_in:'登錄中...',
    Login_failure:'登錄失敗',
    mobile_or_password_cannot_be_empty:'賬號或密碼不能為空',
    Login_successful:'登錄成功',
    mobile_phone_incorrect:'手機號格式不正確',
    enter_password_6_to_18_characters:'請輸入6~18位密碼',
    Retrieve_password:'找回密碼',
    Graphic_verification_code:'圖形驗證碼',
    Click_Refresh_CAPTCHA:'點擊刷新驗證碼',
    Verification_code:'驗證碼',
    New_password:'新密碼',
    Confirm_password:'確認密碼',
    Send_verification_code:'發送驗證碼',
    verification_code_sent:'驗證碼已發送，請註意查收',
    resend:'後重新發送',
    two_passwords_different:'兩次輸入的密碼不一致',
    Password_reset:'密碼已重置',
    SMS_verification_code:'短信驗證碼',
    Set_assword:'設置密碼',
    Click_done_agree:'點擊完成即同意',
    User_agreement:'用戶協議',
    Register_now:'立即註冊',
    Registered_successfully:'註冊成功',
    password_cannot_contain_spaces:'密碼不能包含空格',
    You_not_submitted_information:'您還未提交同行認證資料，請完善個人信息',
    information_pending_review:'您的同行認證資料待審核，請耐心等待審核',
    certification_profile_rejected:'您的同行認證資料被拒絕，請重新提交審核',
    your_account_will_be_banned:'您的賬號被禁止登錄3秒後強製退出',
    Upload_business_license:'上传营业执照',
    Next_new_number:'下一步，新号码',
    phone_number_does_not_match:'手机号码不匹配，请重输',
    new_mobile_cannot_original_mobile:'新手机号码不能为原手机号',
    The_format_incorrect:'格式不正确，请重新选择',
    upload_no_more_than_images:'请上传不超过{0}的图片',
    You_can_only_upload_picture:'最多只能上传1张图片',
    Confirm_remove_this_file:'确定移除此文件',
    save_personal_data:'是否保存個人資料?',
  },
  
  /////////////////////////以下是支付相关/////////////////////////////
  pay:{
    Order_payment:'訂單支付',
    Remaining_time_paid:'支付剩餘時間',
    This_payment:'本次支付',
    Have_paid:'已支付',
    Payment_installments:'分次支付',
    Alipay_payment:'支付寶支付',
    Wechat_Pay:'微信支付',
    scan_pay:'掃碼支付',
    The_how_many_payment:'第{0}次支付',
    Pay_on_deposit:'按定金支付',
    This_minimum_payment:'本次最低支付',
    Pro_rata_payment:'按照比例支付',
    payment_not_less_than:'支付比例不小於',
    There_is_no_limit_amount:'本次不限製支付額度',
    remaining_full_payment:'本次支付剩餘全款',
    payment_unlimited:'本次支付不限製額度',
    scan_the_QR_code_complete_payment:'請掃一掃下方二維碼完成付款',
    open_wechat_or_Alipay_to_scan_the_code:'請打開微信或支付寶掃碼',
    payment_amount_is:'本次支付金額為',
    Paid_full_amount:'全款支付，支付金額為',
    amount_cannot_be_less_than:'輸入的金額不能小於{0}',
    click_Payment_in_installments:'請先點擊分次支付，輸入本次支付金額，再進行',
    Payment_redirection:'支付跳轉中...',
  },

  ///////////////////////////////以下是开票相关/////////////////////////////////
  invo:{
    To_be_invoiced:'待開票',
    Billing_status:'開票狀態',
    Type_of_invoice:'發票種類',
    Invoice_amount:'開票金額',
    Invoice_title:'發票擡頭',
    Taxpayer_identification_number:'納稅人識別號',
    Invoice_type:'發票類型',
    Invoice_has_been_issued:'已開票',
    Paper_invoice:'紙質發票',
    Electronic_invoice:'電子發票',
    Invoice_content:'發票內容',
    Billing_type:'開票種類',
    corporation:'公司',
    personage:'個人',
    Name_of_invoicing_entity:'開票主體名稱',
    Bank_of_deposit:'開戶行',
    Billing_address:'開票地址',
    Airport_transfer_service_charge:'接送機服務費',
    Travel_service_fee:'旅遊服務費',
    invoice_amount_cannot_order_amount:'開票金額不能超過訂單金額',
    invoicing_amount_up_amount_order:'開票金額僅允許在訂單金額的基礎上最多上浮',
    maximum_amount_millions:'輸入開票金額上限為千萬單位',
    Successful_billing:'開票成功',
  },

  //////////////////以下是我的店铺//////////////////
  myshop:{
    Shop_name:'店铺名称',
    Shop_link:'店鋪鏈接',
    Shop_portrait:'店鋪頭像',
    click_image_upload_or_modify:'請點擊圖片進行上傳或修改,建議尺寸',
    Shop_sign_picture:'店招圖片',
    Store_QR_code:'店鋪二維碼',
    Price_allocation:'價格配置',
    Function_configuration:'功能配置',
    is_enable_online_ordering:'是否開啟在線下單與註冊',
    share_your_store_link:'提示:請將您的店鋪鏈接或二維碼分享給直客進行訪問',
    Direct_visitors:'直客在訪問過程中僅會通過您的店鋪查看產品,並且遊客無法與供應商聯系',
    enabled_online_ordering:'你已成功開啟在線下單與註冊功能',
    turned_off_online_ordering:'你已成功關閉在線下單與註冊功能',
    Store_information_saved_successfully:'店鋪信息保存成功',
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/i18n/zh_hk.js